import { fetchUtils, AuthProvider, UserIdentity } from 'react-admin';
const httpClient = fetchUtils.fetchJson;
const authOptions = {
    user : {
        authenticated: true,
        token: localStorage.getItem("token") || undefined,
  }
};

const authProvider: AuthProvider = {
    login: ({ username }) => {
        localStorage.setItem('username', username);
        return Promise.resolve();
    },
    logout: () => {
        return new Promise((res: any) => {
            httpClient(`/logout`, { method: 'GET' })
                .then(() => {
                    localStorage.removeItem('username')
                    localStorage.removeItem('token')
                    res()
                })
                .catch((error) => {
                    console.error('Error during logout:', error);
                    // Даже если logout не удался, очищаем локальное хранилище
                    localStorage.removeItem('username')
                    localStorage.removeItem('token')
                    res()
                })
        })
    },
    checkError: (params) => {
        const status = params.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('username');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    checkAuth: () => {
        if (localStorage.getItem('username'))
            return Promise.resolve()

        return new Promise((res: any, rej) => {
            httpClient(`/api/profile`, { method: 'GET', ...authOptions })
                .then(({ json }) => {
                    try {
                        if (!json.mail || !json.mail.length) {
                            window.location.href = '/#/confirm_email';
                        }
                        localStorage.setItem('username', json.id);
                        res();
                    } catch (error) {
                        console.error('Error processing profile data:', error);
                        rej(error);
                    }
                })
                .catch((error) => {
                    console.error('Error checking auth:', error);
                    rej(error);
                })
        })
    },
    // ИСПРАВЛЕНО: Возвращаем Promise.resolve() вместо Promise.reject('Unknown method')
    // для устранения ошибки React Query "Unknown method"
    getPermissions: () => Promise.resolve(),
    getIdentity: (): Promise<UserIdentity> => {
        return new Promise((res: any) => {
            httpClient(`/api/profile`, { method: 'GET', ...authOptions })
                .then(({ json }) => {
                    res({
                        id: json.id,
                        avatar: json.photo,
                        roles: json.roles,
                        role: json.role,
                        memberOf: json.memberOf,
                        mail: json.mail,
                        isAppAdmin: json.isAppAdmin,
                        isRoleAdmin: json.isRoleAdmin
                    })
                })
                .catch(() => res({}))
        })
    },
}

export default authProvider;

export const fetchProvider = (path: string, method?: string, body?: any) => {
    try {
        const token = localStorage.getItem('token');
        
        // Валидация пути
        if (!path || typeof path !== 'string') {
            console.error('Invalid path provided to fetchProvider:', path);
            return Promise.reject(new Error('Invalid path'));
        }

        const fetchOptions: RequestInit = {
            method: method || 'GET',
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        };

        // Добавляем тело запроса только для методов, которые его поддерживают
        if (body && method !== 'GET' && method !== 'HEAD') {
            try {
                fetchOptions.body = JSON.stringify(body);
            } catch (error) {
                console.error('Error stringifying body:', error);
                return Promise.reject(new Error('Invalid request body'));
            }
        }

        // Добавляем токен авторизации если он есть
        if (token?.trim()) {
            (fetchOptions.headers as Headers).append('Authorization', token);
        }

        return fetch(path, fetchOptions)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response;
            })
            .catch(error => {
                console.error('Fetch error in fetchProvider:', error);
                throw error;
            });
    } catch (error) {
        console.error('Error in fetchProvider:', error);
        return Promise.reject(error);
    }
}
